import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { AsistencialAppointmentForm } from '../../components/Agenda/AsistencialAppointmentForm';
import { getAsistencialAppointmentSchema } from '../../components/Validations/FormValidationSchema';

export const AddAsistencialAppointmentContainer = (props) => {
    return (
        <AddAsistencialAppointmentFormik
            onSubmit={props.onSubmit}
            onClose={props.onClose}
            onBack={props.onBack}
            currentPatient={props.currentPatient}
            masterdata={props.masterdata}
            formType="new"
        />
    );
}
AddAsistencialAppointmentContainer.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const AddAsistencialAppointmentFormik = withFormik({
    mapPropsToValues: props => ({
        patient: props.currentPatient || null,
        visitType: null,
        specialty: null,
        medicalInsurance: null,
        medicalInsurancePlan: null,
        medicalService: null,
        practitioner: null,
        isFirstTime: false,
        selectedDate: null,
        start: null,
        end: null,
        desc: '',
        location: '',
        patientNotes: '',
        notifyPatient: false,
        patientEmail: '',
        patientOriginalEmail: '',
    }),
    validationSchema: getAsistencialAppointmentSchema(),
    handleSubmit: (values, formikBag) => {
        formikBag.props.onSubmit(values);
    },
    displayName: 'AddAsistencialAppointment',
})(AsistencialAppointmentForm);

AddAsistencialAppointmentFormik.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
